import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/reply-logo-compact.png'
import _imports_1 from '@/assets/icons/fb-icon.svg'
import _imports_2 from '@/assets/auth-big-img.svg'


const _hoisted_1 = { class: "auth__container" }
const _hoisted_2 = { class: "flex-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "auth__reply-logo",
  src: _imports_0,
  alt: "Reply200"
}, null, -1)
const _hoisted_4 = { class: "auth__form connect-social-dialog" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Set up your account", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "info big mb-4" }, " Please connect one of your social media business accounts. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex-center auth__decoration" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Welcome"
  })
], -1)

import VButton from '@/components/VButton.vue';
import { useFacebookStore } from '@/stores/facebook';
import { useTiktokStore } from '@/stores/tiktok';


export default /*#__PURE__*/_defineComponent({
  __name: 'GettingStarted',
  setup(__props) {

const facebookStore = useFacebookStore()
const tiktokStore = useTiktokStore()



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(VButton, {
          big: "",
          clear: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(facebookStore).connectFacebook()))
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" Facebook Business ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/",
          class: "mt-2 mb-3 clickable"
        }, {
          default: _withCtx(() => [
            _createTextVNode("I will do this later")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_8
  ]))
}
}

})